import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1846.30769,1476.92308 L1846.30769,1920 L74,1920 L74,1476.92308 L1846.30769,1476.92308 Z M1698.61538,1624.61538 L221.692308,1624.61538 L221.692308,1772.30769 L1698.61538,1772.30769 L1698.61538,1624.61538 Z M1109.75138,0.0590769231 L1619.14215,1227.08677 L1482.67446,1283.65292 L1317.70215,886.065231 L602.576,886.065231 L437.603692,1283.65292 L301.136,1227.08677 L810.526769,0.0590769231 L1109.75138,0.0590769231 Z M1011.09292,147.751385 L909.332923,147.751385 L663.868308,738.372923 L1256.40985,738.372923 L1011.09292,147.751385 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconTextColorLine = /*#__PURE__*/function (_Component) {
  _inherits(IconTextColorLine, _Component);

  var _super = _createSuper(IconTextColorLine);

  function IconTextColorLine() {
    _classCallCheck(this, IconTextColorLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconTextColorLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconTextColor",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconTextColorLine.displayName = "IconTextColorLine";
  return IconTextColorLine;
}(Component);

IconTextColorLine.glyphName = 'text-color';
IconTextColorLine.variant = 'Line';
IconTextColorLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconTextColorLine;
export { IconTextColorLine };